import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {VisitRequestDto} from "../dto/VisitRequestDto";
import {TENANT_ID} from "../../../constants/Profile";

export const VisitRequestApi = {

    registerVisitRequest: async (body: VisitRequestDto) => {
        try {
            const requestUrl = '/v1/vms/visit/request/register';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createVisitRequest: async (body: VisitRequestDto) => {
        try {
            const requestUrl = '/v1/vms/visit/request/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    updateVisitRequest: async (body: VisitRequestDto) => {
        try {
            const requestUrl = '/v1/vms/visit/request/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    updateRequestRemarks: async (id: string, body: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString("/v1/vms/visit/request/update/remarks", params);
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    getLastHostInfo: async (hostStaffNumber: string, hostEmail: string) => {
        try {
            const params = new Map<string, string>();
            params.set('hostStaffNumber', hostStaffNumber);
            params.set('hostEmail', hostEmail);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/getLastHostInfo', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    getHostInfoList: async (hostFullName: string) => {
        try {
            const params = new Map<string, string>();
            params.set('hostFullName', hostFullName);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/getHostInfoList', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    inviteVisitRequest: async (body: VisitRequestDto) => {
        try {
            const requestUrl = '/v1/vms/visit/request/invite';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    registerEmployeeVehicleRequest: async (body: VisitRequestDto) => {
        try {
            const requestUrl = '/v1/vms/visit/request/employee/vehicle/apply';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getVisitRequestDetailById: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getPendingApprovalList: async () => {
        try {
            const requestUrl = '/v1/vms/visit/request/pending/approval/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    approve: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/approve', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    reject: async (id: string, body: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/reject', params);
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    checkEmployeeByMobile: async (mobile: string) => {
        try {
            const params = new Map<string, string>();
            params.set('mobile', mobile);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/employee/check', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    searchEmployeeByName: async (name: string) => {
        try {
            const params = new Map<string, string>();
            params.set('name', name);
            params.set('tenantId', TENANT_ID);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/employee/searchByName', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    withdraw: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            params.set('tenantId', TENANT_ID);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visit/request/withdraw', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

};
